<template>
  <div>
    <basic-container>
      <div style="height: 20px"></div>
      <el-form :inline="true" ref="form" :model="form">
        <el-row>
          <el-col span="7">
            <el-form-item label="项目名称" abel-width="80px" style="width: 100%; display: flex">
              <el-select
                style="width: 100%; flex: 1"
                v-model="form.projectId"
                placeholder="请选择项目"
                size="small"
              >
                <el-option
                  v-for="(item, index) in projectIdList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col span="7">
            <el-form-item label="工单类型" label-width="80px" style="width: 100%; display: flex">
              <el-select
                v-model="form.moduleType"
                placeholder="请选择工单类型"
                style="width: 100%"
              >
                <el-option
                  v-for="item in moduleTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="7">
            <el-form-item label="完成标准"  label-width="80px" style="width: 100%; display: flex;"  prop="criterion"  >
              <el-select
                style="width: 100%; flex: 1"
                v-model="form.criterion"
                placeholder="请选择完成标准"
                size="small"
              >
              <el-option
                  v-for="(item, index) in norm"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="10">
            <el-form-item label="完成日期" required prop="finishTime" :rules="[{ required: true, message: '请选择日期', trigger: 'blur' },]" >
                <el-date-picker
                  :clearable="false"

                  v-model="form.finishTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>


            </el-form-item>
            <!-- <el-form-item label="开始时间" style="width: 100%; display: flex">
              <div style="width: 100%; flex: 1">
                <el-date-picker
                  style="width: 100%"
                  v-model="form.beginDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择开始时间"
                >
                </el-date-picker>
              </div>
            </el-form-item> -->
          </el-col>
          <!-- <el-col span="6">
            <el-form-item label="结束时间" style="width: 100%; display: flex">
              <div style="width: 100%; flex: 1">
                <el-date-picker
                  style="width: 100%"
                  v-model="form.endDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请输入结束时间"
                >
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col> -->
          <el-col span="10"></el-col>
          <el-col span="4" style="text-align:right;">
              <el-button type="primary" @click="onSubmit">搜索</el-button>
              <el-button type="primary" @click="searchReset">清空</el-button>

          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params"/>
    </basic-container>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import urlSettings from '@/config/url-settings';
import {modulesSetting} from "@/api/crmedical/order/order-add";
import WebReport from '@/components/web-report';
import {getProjectList,getDictData} from "@/api/crmedical/report/questionnaire.js";
export default {
  components: {
    WebReport,
  },
  data() {

    var date=new Date();
        date.setDate(1);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
    return {
      url: '',
      form: {
        projectId: [],
        projectName: "",
        criterion:'',
        moduleType: "",
        moduleTypeName: "",
        beginDate:dayjs(date).format('YYYY-MM-DD'),
        endDate: dayjs().format('YYYY-MM-DD'),
        finishTime:[new Date(date), new Date()],
      },
      projectList: [],
      moduleTypeList: [],
      oldOptions: [],
      params: {
        // reportlet:urlSettings.VUE_APP_ENVIRONMENT +  '/workOrderServiceReport.cpt',
      },
      dic: [],
      norm:[],
    };
  },
  watch:{
    'form.projectId': function (val,oldVal) {
      if(val){
        this.modulesSetting(val);
      }
    },
  },
  methods: {
    modulesSetting(projectId){
      this.form.moduleType = "";
      this.form.moduleTypeName = "";
      modulesSetting(projectId).then((data)=>{
        this.moduleTypeList = data.data;
        if (this.moduleTypeList.length > 0) {
          //默认设置报修服务，若没有则默认第一个
          for(let index in this.moduleTypeList){
            let itemModuleType = this.moduleTypeList[index];
            if( itemModuleType.dictValue === "报修服务"){
               this.form.moduleType = itemModuleType.dictKey;
               this.form.moduleTypeName = itemModuleType.dictValue;
               break;
            }
          }

          if(this.form.moduleTypeName ===""){
            this.form.moduleType = this.moduleTypeList[0].dictKey;
            this.form.moduleTypeName = this.moduleTypeList[0].dictValue;
          }
        }
      });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.params.projectId = this.form.projectId;
          this.form.projectName = document.querySelector('input[placeholder="请选择项目"]').value;
          this.params.projectName = document.querySelector('input[placeholder="请选择项目"]').value;

          this.params.moduleType = this.form.moduleType;
          this.form.moduleTypeName = document.querySelector('input[placeholder="请选择工单类型"]').value;
          this.params.moduleTypeName = document.querySelector('input[placeholder="请选择工单类型"]').value;
          this.params.beginDate = dayjs(this.form.finishTime[0]).format('YYYY-MM-DD');
          this.params.endDate = dayjs(this.form.finishTime[1]).format('YYYY-MM-DD');
          this.params.criterion = this.form.criterion;
          // if(!this.form.beginDate){
          //   this.params.beginDate ='';
          // }else{
          //   this.params.beginDate = this.form.beginDate;
          // }
          // if(!this.form.endDate){
          //   this.params.endDate ='';
          // }else{
          //   this.params.endDate = this.form.endDate;
          // }
          this.url = "https://rpt-test.pms1.cn/webroot/decision/view/report?viewlet=hpss/workOrderServiceReport.cpt";
          setTimeout(() => {
            console.log(this.params);
            this.$refs.WebReport.regroupUrl();
          }, 0);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    searchReset(){
      if (this.projectIdList.length > 0) {
        this.form.projectId = this.projectIdList[0].id;
        this.form.projectName = this.projectIdList[0].name;
      }
      var date=new Date();
      date.setDate(1);

      this.form.beginDate = dayjs(date).format('YYYY-MM-DD');
      this.form.endDate = dayjs().format('YYYY-MM-DD');

      this.form.moduleType = "";
      this.form.moduleTypeName = "";
      if (this.moduleTypeList.length > 0) {
        //默认设置报修服务，若没有则默认第一个
        for(let index in this.moduleTypeList){
          let itemModuleType = this.moduleTypeList[index];
          if( itemModuleType.dictValue === "报修服务"){
            this.form.moduleType = itemModuleType.dictKey;
            this.form.moduleTypeName = itemModuleType.dictValue;
            break;
          }
        }

        if(this.form.moduleTypeName ===""){
          this.form.moduleType = this.moduleTypeList[0].dictKey;
          this.form.moduleTypeName = this.moduleTypeList[0].dictValue;
        }
      }
      this.onSubmit();
    },

    async initPropertyList() {
      await getDictData({code:'order_finish_standard'}).then(res=>{
        this.norm = res.data;
        this.form.criterion = this.norm[0]?this.norm[0].dictKey:'';

      })
      await getProjectList({}).then((res) => {
        this.projectIdList = res.data;
        if (this.projectIdList.length > 0) {
          this.form.projectId = this.projectIdList[0].id;
          this.form.projectName = this.projectIdList[0].name;
        }

        modulesSetting(this.form.projectId).then((data)=>{
          this.moduleTypeList = data.data;
          if (this.moduleTypeList.length > 0) {
            //默认设置报修服务，若没有则默认第一个
            for(let index in this.moduleTypeList){
              let itemModuleType = this.moduleTypeList[index];
              if( itemModuleType.dictValue === "报修服务"){
                this.form.moduleType = itemModuleType.dictKey;
                this.form.moduleTypeName = itemModuleType.dictValue;
                break;
              }
            }

            if(this.form.moduleTypeName ===""){
              this.form.moduleType = this.moduleTypeList[0].dictKey;
              this.form.moduleTypeName = this.moduleTypeList[0].dictValue;
            }
          }

          var reportUrl = urlSettings.BASE_REPORT_URL;
        this.url = reportUrl.split('?')[0];
        console.log(this.url);

          // this.url = "http://localhost:8075/WebReport/ReportServer?reportlet=hpss_test/workOrderServiceReport.cpt";
          this.url = "https://rpt-test.pms1.cn/webroot/decision/view/report?viewlet=hpss/workOrderServiceReport.cpt";
          this.params.projectId = `${this.projectIdList[0].id}`;
          this.params.projectName = `${this.projectIdList[0].name}`;
          this.params.moduleType = this.form.moduleType;
          this.params.moduleTypeName = this.form.moduleTypeName;
          this.params.criterion = this.form.criterion;

        this.params.projectId = `${this.projectIdList[0].id}`;
        this.params.beginDate = dayjs(this.form.finishTime[0]).format('YYYY-MM-DD');
        this.params.endDate = dayjs(this.form.finishTime[1]).format('YYYY-MM-DD');
        this.params.time = `完成日期:${dayjs(this.form.finishTime[0]).format('YYYY年MM月DD日')}-${dayjs(this.form.finishTime[1]).format('YYYY年MM月DD日')}`

          setTimeout(() => {
            console.log(this.params);
            this.$refs.WebReport.regroupUrl();
          }, 0);
        });
      });
    },
  },

  created() {
    this.initPropertyList();

  },
};

</script>

<style></style>
